// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6ad069e9","455":"c2ea513c","488":"ed3c7d7c","977":"9303253c"}[chunkId] + ".chunk.js";
};